import { Stack, Text } from "@chakra-ui/react";
import { SimpleList } from "@/components/list";

export const FAQS = [
  {
    title: "What is the difference between Network Monitoring and Network Observability?",
    content: (
      <SimpleList
        points={[
          "Network Monitoring (NMS) focuses on real-time tracking of network health, uptime, and performance metrics.",
          "Network Observability goes beyond monitoring, using AI-driven analytics, telemetry, and machine learning to predict failures, automate responses, and provide deeper insights.",
        ]}
      />
    ),
  },
  {
    title: "How does network observability improve IT operations?",
    content: (
      <Stack>
        <Text>Network observability helps IT teams by: </Text>
        <SimpleList
          points={[
            "Providing centralized, real-time visibility across network infrastructure.",
            "Detecting and resolving performance issues before they impact users.",
            "Reducing operational costs through automation and AI-driven insights.",
            "Enhancing security posture with continuous threat monitoring.",
          ]}
        />
      </Stack>
    ),
  },
  {
    title: "What types of networks can be monitored with NMS?",
    content: (
      <Stack>
        <Text>NMS solutions support: </Text>
        <SimpleList
          points={[
            "Cloud and hybrid networks (AWS, Azure, Google Cloud).",
            "Enterprise LAN and WAN environments.",
            "Wireless and IoT networks.",
            "Data center and colocation facilities.",
          ]}
        />
      </Stack>
    ),
  },
  {
    title: "How do AI and machine learning enhance network monitoring?",
    content: (
      <Stack>
        <Text>AI and ML provide: </Text>
        <SimpleList
          points={[
            "Predictive analytics to identify trends and prevent failures.",
            "Automated anomaly detection to flag suspicious network activity.",
            "Intelligent traffic optimization for better bandwidth allocation.",
            "Self-healing networks that auto-correct performance issues.",
          ]}
        />
      </Stack>
    ),
  },
  {
    title: "How can businesses improve network security using observability tools?",
    content: (
      <Stack>
        <Text>Network observability enhances security by: </Text>
        <SimpleList
          points={[
            "Detecting unauthorized access attempts and cyber threats.",
            "Providing automated alerts for unusual network activity.",
            "Ensuring compliance with regulatory standards.",
            "Analyzing encrypted traffic without compromising privacy.",
          ]}
        />
      </Stack>
    ),
  },
  {
    title: "What are the key benefits of cloud-based NMS?",
    content: (
      <Stack>
        <Text>Cloud-based NMS provides: </Text>
        <SimpleList
          points={[
            "Scalability – Easily monitor thousands of network endpoints.",
            "Remote access – IT teams can manage networks from anywhere.",
            "Real-time updates – No manual patching or software maintenance.",
            "Integration with cloud-native security tools.",
          ]}
        />
      </Stack>
    ),
  },
  {
    title: "How does OneMind Services ensure seamless network observability?",
    content: (
      <Stack>
        <Text>OneMind Services uses: </Text>
        <SimpleList
          points={[
            "AI-powered observability platforms for real-time insights.",
            "Customizable alerting and reporting to suit business needs.",
            "24/7 monitoring support to ensure network reliability.",
            "Cloud-first approach for agile, scalable network observability.",
          ]}
        />
      </Stack>
    ),
  },
  {
    title: "How does network observability reduce downtime?",
    content:
      "It proactively detects anomalies, predicts failures, and automates issue resolution, preventing disruptions before they impact operations.",
  },
  {
    title: "What metrics can NMS track?",
    content:
      "NMS monitors latency, packet loss, bandwidth usage, device health, security threats, and network traffic patterns to optimize performance.",
  },
  {
    title: "Can network observability help with regulatory compliance?",
    content:
      "Yes! It provides real-time audit logs, security monitoring, and automated compliance reports for GDPR, SOC 2, and other regulations.",
  },
  {
    title: "What is the role of telemetry in network observability?",
    content:
      "Telemetry collects real-time performance data from network devices, enabling AI-driven insights and faster troubleshooting.",
  },
  {
    title: "How does network monitoring improve cloud security?",
    content:
      "It identifies suspicious activity, detects unauthorized access, and prevents data breaches through real-time alerts and automated responses.",
  },
  {
    title: "Can NMS integrate with existing IT systems?",
    content:
      "Yes! Most NMS solutions support integration with cloud platforms, SIEM tools, firewalls, and enterprise IT management systems.",
  },
  {
    title: "How does AI enhance network observability?",
    content:
      "AI enables predictive analytics, automated troubleshooting, anomaly detection, and intelligent traffic routing, reducing manual IT workload.",
  },
];
